var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-field',{attrs:{"options":_vm.options,"propValue":_vm.propValue},on:{"change":_vm.changeHandle,"input":_vm.inputHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }